import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgItalicLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 11.5,5.015625 c -0.4142,0 -0.75,0.3358004 -0.75,0.75 0,0.4142196 0.3358,0.75 0.75,0.75 h 2.005859 l -3.5722652,12.5 H 7.5 c -0.4142096,0 -0.75,0.3358 -0.75,0.75 0,0.4142 0.3357904,0.75 0.75,0.75 h 2.976563 c 0.0166,6e-4 0.03243,6e-4 0.04883,0 H 13.5 c 0.4142,0 0.75,-0.3358 0.75,-0.75 0,-0.4142 -0.3358,-0.75 -0.75,-0.75 h -2.005859 l 3.572265,-12.5 H 17.5 c 0.4142,0 0.75,-0.3357804 0.75,-0.75 0,-0.4141996 -0.3358,-0.75 -0.75,-0.75 z"
	})]
});
export default SvgItalicLine;
